import { Typography } from '@mui/material'

const HelpText = () => (
  <div className='p-5'>
    <Typography variant='h4'>Company details & contacts</Typography>
    <p>Maintain the company identity used for the account, together with the main contact and billing email. The main contact belongs to the parent account, not the currently selected child client.</p>
    <Typography variant='h5'>Keeping details current</Typography>
    <p>Use a monitored billing email because invoices, payment and credit communications are sent there. Update the main contact when the person responsible for the account changes.</p>
  </div>
)

export default HelpText
